export default "__VITE_ASSET__qDdh9bI___"